import styled, { CSSObject, keyframes } from 'styled-components';

import { COLORS } from '../../../assets/js/constants';

export interface ICustomDotsStyles {
    dotsContainer?: CSSObject,
    dot?: CSSObject,
    dotContainer?: CSSObject,
    activeDot?: CSSObject,
}

export const Dot = styled.div<{ active?: boolean, customStyles?: ICustomDotsStyles }>`
  height: 100%;
  width: 100%;
  border-radius: 2px;
  background: ${COLORS.black};
  opacity: 0.1;
  transition: opacity .3s ease;
  ${p => p.customStyles?.dot ?? ''};

  &:hover {
    opacity: ${({ active }) => active ? 1 : 0.45};
  }
`;

export const DotContainer = styled.div<{ active?: boolean, customStyles?: ICustomDotsStyles }>`
  position: relative;
  width: ${({ active }) => active ? '48px' : '24px'};
  height: 4px;
  margin: 0 4px;
  cursor: pointer;
  transition: width .3s ease;
  ${p => p.customStyles?.dotContainer ?? ''};
`;

const activeLineAnimation = keyframes`
  0% { width: 0; }
  100% { width: 100%; }
`;

export const ActiveLine = styled.div<{ active?: boolean, time?: number, customStyles?: ICustomDotsStyles }>`
  display: ${({ active }) => active ? 'initial' : 'none'};
  position: absolute;
  top: 0;
  left: 0;
  background: ${COLORS.black};
  width: ${({ active }) => active ? '100%' : '0%'};
  height: 100%;
  border-radius: 2px;
  animation-name: ${activeLineAnimation};
  animation-duration: ${({ time }) => time || 0}s;
  animation-iteration-count: 1;
  ${p => p.customStyles?.activeDot ?? ''};
`;

export const DotsContainer = styled.div< {customStyles?: ICustomDotsStyles }>`
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  bottom: 26px;
  z-index: 10;
  flex-wrap: nowrap;
  ${p => p.customStyles?.dotsContainer ?? ''};
`;
